/* eslint-disable react/style-prop-object */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, FormattedNumber } from 'react-intl';
import moment from 'moment';
import { fromCents, getCurrencyCode } from 'utils/helpers';
import Paginate from 'components/Credit24/SelfService/Paginate';

const propTypes = {
  transactions: PropTypes.array,
};

class Transactions extends Component {
  render() {
    const { transactions } = this.props;
    const { intl } = this.context;

    const details = (item) => {
      if (item.type === 'ExtraService') {
        const extraService = `transactions.ExtraService.${item.description}`;
        return { serviceName: intl.formatMessage({ id: extraService }) };
      }
      return { accountNumber: item.description };
    };

    return (
      <Paginate
        data={transactions}
        WrapperComponent={({ children }) => (
          <table className="table table--transactions">
            <tbody>
              {children}
            </tbody>
          </table>
        )}
        RowItemComponent={({ data }) => (
          <tr>
            <td>
              {data.type !== 'Unknown'
                && (
                <FormattedMessage
                  id={`transactions.${data.type}.title`}
                  values={details(data)}
                />
                )}
            </td>
            <td>
              {moment(data.created).format('L')}
            </td>
            <td>
              <FormattedNumber
                style="currency"
                currency={getCurrencyCode()}
                value={fromCents(data.amount)}
              />
            </td>
          </tr>
        )}
        rowKeyAttr={['created', 'type', 'amount']}
      />
    );
  }
}

Transactions.propTypes = propTypes;
Transactions.contextTypes = {
  intl: PropTypes.object,
};

export default Transactions;
